<template>
  <div
    :id="option.id"
    class="fade modal"
    role="dialog"
  >
    <div class="choose-modal modal-dialog">
      <!-- Modal content -->
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
          >
            &times;
          </button>

          <h4 class="modal-title text-left">
            {{ option.title }}
          </h4>
        </div>

        <div class="modal-body text-left">
          <!--
            <div class="bg-primary text-16" style="padding: 10px">
            備註： {{elementRemark}}
            </div>
          -->
          <div class="text-left">
            <button
              v-for="elem in productList"
              v-if="elem.active"
              class="btn btn-choose-element btn-default"
              :class="{'active': elem.item_id === curClick}"
              @click="() => clickElement(elem)"
            >
              {{ elem.name }}<span>&nbsp;&nbsp;${{ getPrice(elem.price) }}</span>

              <br>

              <div class="text-remark">
                <small>&nbsp;{{ elem.remark }}&nbsp;</small>
              </div>
            </button>
          </div>

          <div>
            <hr>

            <br>

            <div class="input-group">
              <span class="input-group-addon">排<div class="inline-block w-35" />序</span>

              <input
                ref="sort"
                v-model="productInfo.sort"
                class="form-control"
                placeholder=""
                type="text"
                maxlength="4"
                @keyup="veritySort"
              >
            </div>

            <br>

            <div class="input-group">
              <span class="input-group-addon">價<div class="inline-block w-35" />格</span>

              <input
                ref="price"
                v-model="productInfo.newPrice"
                class="form-control"
                placeholder=""
                type="text"
                maxlength="9"
                @keyup="verityPrice"
              >
            </div>

            <br>

            <div class="input-group">
              <span class="input-group-addon">必選項目</span>

              <div
                class="h-38 radio text-left"
                style="border-left: 1px solid #d2d6de;"
              >
                <label class="m-l-15">
                  <input
                    v-model="productInfo.is_mandatory"
                    type="radio"
                    name="productInfoMandatoryRadio"
                    :value="1"
                    style="top: 12px;"
                  >

                  <div style="top: 8px; left: 8px;">是</div>
                </label>

                <label class="m-l-15">
                  <input
                    v-model="productInfo.is_mandatory"
                    type="radio"
                    name="productInfoMandatoryRadio"
                    :value="0"
                    style="top: 12px;"
                  >

                  <div style="top: 8px; left: 8px;">否</div>
                </label>
              </div>
            </div>

            <br>

            <div class="input-group">
              <span class="input-group-addon">預設選取</span>

              <div
                class="h-38 radio text-left"
                style="border-left: 1px solid #d2d6de;"
              >
                <label class="m-l-15">
                  <input
                    v-model="productInfo.is_default"
                    type="radio"
                    name="defaultRadio"
                    :value="1"
                    style="top: 12px;"
                  >

                  <div style="top: 8px; left: 8px;">是</div>
                </label>

                <label class="m-l-15">
                  <input
                    v-model="productInfo.is_default"
                    type="radio"
                    name="defaultRadio"
                    :value="0"
                    style="top: 12px;"
                  >

                  <div style="top: 8px; left: 8px;">否</div>
                </label>
              </div>
            </div>

            <br>

            <div class="input-group">
              <span class="input-group-addon">選購數量</span>

              <div>
                <input
                  ref="minLimit"
                  v-model="productInfo.min_limit"
                  style="width: calc(50% - 10px)"
                  class="c-auto form-control"
                  placeholder="0為無上限"
                  type="text"
                  maxlength="9"
                  @keyup="verityMinLimit"
                >

                <span
                  class="pull-left"
                  style="line-height: 38px; width: 20px"
                >~</span>

                <input
                  ref="maxLimit"
                  v-model="productInfo.max_limit"
                  style="width: calc(50% - 10px)"
                  class="c-auto form-control"
                  placeholder="0為無上限"
                  type="text"
                  maxlength="9"
                  @keyup="verityMaxLimit"
                >
              </div>
            </div>

            <br>
          </div>
        </div>

        <div class="modal-footer">
          <button
            class="btn btn-primary"
            data-dismiss="modal"
            @click="trigger(option.event)"
          >
            確定
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  props: {
    option: {
      type: Object,
      required: true
    },

    productList: Array
  },

  data () {
    return {
      selected: 0,
      inputValue: '',
      elementRemark: '',
      curClick: 0
    }
  },

  computed: {
    productInfo () {
      var self = this
      var empty = {
        product_id: 0,
        sort: '',
        newPrice: '',
        is_mandatory: '',
        is_default: '',
        min_limit: '',
        max_limit: ''
      }
      if (self.curClick) {
        var p = this.productList.find(function (p) {
          return p.item_id === self.curClick
        })
        if (p) return p
        else return empty
      } else return empty
    }
  },

  methods: {
    showRemark (elem) {
      this.elementRemark = elem.remark
    },

    hideRemark () {
      this.elementRemark = ''
    },

    trigger (event) {
      this.$emit('trigger', event)
    },

    clickElement (elem) {
      this.curClick = elem.item_id
    },

    clearAll () {
      for (var i = 0; i < this.elementList.length; i++) {
        this.elementList[i].active = false
      }
    },

    getPrice (price) {
      return Math.floor(price * 100) / 100
    },

    veritySort () {
      var e = $(this.$refs.sort)
      this.productInfo.sort = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },

    verityMinLimit () {
      var e = $(this.$refs.minLimit)
      this.productInfo.min_limit = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },

    verityMaxLimit () {
      var e = $(this.$refs.maxLimit)
      this.productInfo.max_limit = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },

    verityPrice () {
      var e = $(this.$refs.price)
      this.productInfo.price = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    }
  }
}
</script>

<style lang="sass">
.text-remark
  opacity: .7
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
.element-block
  border: 1px solid #eee
  padding: 30px 15px
.choose-modal.modal-dialog
  width: 80%
  min-height: 80vh
  .modal-content
    min-height: 80vh
.btn-choose-element
  margin: 8px
  padding: 10px
  font-size: 18px
  width: calc(20% - 16px)
.btn-choose-element.active
  background-color: #3c8dbc !important
  border-color: #367fa9 !important
  color: #ffffff !important
@media screen and (max-width: 767px)
  .choose-modal.modal-dialog
    width: calc(100vw - 20px)
  .btn-choose-element
    font-size: 16px
    width: calc(100% - 16px)
@media screen and (max-width: 991px)
  .btn-choose-element
    font-size: 16px
    width: calc(50% - 16px)
</style>



// WEBPACK FOOTER //
// ProductInfoModal.vue?24df9c6e